export default "__VITE_ASSET__CAg3J0_p__"